import { Button } from '@brain/ui'
import { useTranslation } from 'react-i18next'

/** Unknown route – usually a stale app version from the offline cache right after a deploy: reloading helps. */
export function NotFound() {
  const { t } = useTranslation()
  return (
    <div className="flex min-h-dvh flex-col items-center justify-center gap-3 bg-page px-4 text-center">
      <p className="text-[15px] text-text-1">{t('common.notFound')}</p>
      <p className="max-w-sm text-[13px] text-meta">{t('common.notFoundHint')}</p>
      <Button onClick={() => window.location.reload()}>{t('common.reload')}</Button>
    </div>
  )
}
